export function restorePanelDisclosure(panel) {
    const disclosure = panel.querySelector('[data-nurse-performance-disclosure]')
    const key = panel.dataset.nursePerformanceDisclosureStorageKey

    if (!disclosure || !key) return false

    try {
        const saved = window.sessionStorage.getItem(key)
        if (saved === 'collapsed' || saved === 'expanded') {
            disclosure.checked = saved === 'expanded'
        }
    } catch {
        // Keep the default disclosure usable when browser storage is unavailable.
    }

    return !disclosure.checked
}

export function savePanelDisclosure(panel) {
    const disclosure = panel.querySelector('[data-nurse-performance-disclosure]')
    const key = panel.dataset.nursePerformanceDisclosureStorageKey

    if (!disclosure || !key) return

    try {
        window.sessionStorage.setItem(key, disclosure.checked ? 'expanded' : 'collapsed')
    } catch {
        // Folding still works for this visit when browser storage is unavailable.
    }
}
